import * as React from 'react';
import videojs from 'video.js';
import type Player from 'video.js/dist/types/player';

import 'video.js/dist/video-js.css';

type PlayerOptions = Parameters<typeof videojs>[1];

interface IVideoPlayerProps {
  options?: PlayerOptions;
  sources: { src: string; type: string };
  onReady?: (player: Player) => void;
}

const initialOptions: PlayerOptions = {
  controls: true,
  fluid: true,
  controlBar: {
    volumePanel: { inline: false },
  },
};

export const ProductVideo: React.FC<IVideoPlayerProps> = ({
  options,
  sources,
  onReady,
}) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const playerRef = React.useRef<Player>(undefined);

  React.useEffect(() => {
    if (!playerRef.current && videoRef.current) {
      const player = videojs(videoRef.current, {
        ...initialOptions,
        ...options,
        sources: [{ src: sources.src, type: sources.type }],
      });
      player.ready(() => {
        playerRef.current = player;
        onReady?.(player);
      });
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = undefined;
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (playerRef.current) {
      const player = playerRef.current;
      player.pause();
      player.src({ src: sources.src, type: sources.type });
      player.load();
    }
  }, [sources]);

  return (
    <div>
      <video ref={videoRef} className="video-js vjs-big-play-centered" />
    </div>
  );
};
